import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import quote from '../services/QuoteService';
import { quote_slice_name, quote_thunks } from '../constants/quote';
import { getQuoteApplicantIndexFromMeta } from './QuoteSelectors';
import {
  getApplication,
  postAddApplicant,
  deleteApplicantById,
  postApplicationQuoteDate,
} from './ApplicationSlice';

export const initialData = {
  loading: false,
  error: false,
  valid: false,
  data: {
    id: null,
    quoteCreatedDate: null,
    quoteAgeDate: null,
    adviserAtFirmLocationId: null,
    initialIndemnityPercentage: 0,
    initialCommissionSacrificePercentage: 0,
    premium: 0,
    lifetimePremium: 0,
    unloadedPremium: 0,
    discount: 0,
    quoteApplicants: [],
  },
  document: {
    loading: false,
    data: null,
    error: false,
  },
};

export const getQuotePrice = createAsyncThunk(
  quote_thunks.QUOTE_GET_QUOTE_PRICE,
  async (applicationId) => {
    const response = await quote.getQuotePrice(applicationId);
    return response.data;
  }
);

export const openQuoteDocument = createAsyncThunk(
  quote_thunks.QUOTE_OPEN_QUOTE_DOCUMENT,
  async ({ url, applicationId }, { rejectWithValue }) => {
    try {
      const response = await quote.openQuoteDocument(url, applicationId);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const quoteSlice = createSlice({
  name: quote_slice_name,
  initialState: initialData,
  reducers: {
    reset() {
      return initialData;
    },
    setInvalid(state) {
      state.valid = false;
    },
  },
  extraReducers: {
    [getQuotePrice.pending]: (state) => {
      state.loading = true;
      state.valid = false;
    },
    [getQuotePrice.fulfilled]: (state, action) => {
      const {
        data,
        data: { id },
      } = action.payload;
      state.id = id;
      state.error = false;
      state.loading = false;
      state.valid = true;
      state.data = data;
    },
    [getQuotePrice.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
      state.valid = false;
    },
    [getApplication.pending]: (state) => {
      state.loading = true;
    },
    [getApplication.fulfilled]: (state, action) => {
      if (action.payload.data?.quote) {
        state.data = action.payload.data?.quote;
        if (action.payload.data?.quote?.premium) {
          state.valid = true;
        }
      } else {
        state.data = initialData.data;
        state.valid = false;
      }
      state.loading = false;
    },
    [getApplication.rejected]: (state) => {
      state.loading = false;
    },
    [postAddApplicant.pending]: (state) => {
      state.valid = false;
    },
    [deleteApplicantById.pending]: (state) => {
      state.loading = true;
      state.valid = false;
    },
    [deleteApplicantById.fulfilled]: (state, action) => {
      const index = getQuoteApplicantIndexFromMeta(state, action);
      if (index !== -1) {
        state.data.quoteApplicants.splice(index, 1);
      }
      state.loading = false;
    },
    [deleteApplicantById.rejected]: (state) => {
      state.loading = false;
    },
    [postApplicationQuoteDate.fulfilled]: () => {
      return initialData;
    },
  },
});

export const { reset, setInvalid } = quoteSlice.actions;

export default quoteSlice;
